import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Jwt from "@/common/utils/jwt";
import { API_URL } from "@/config/config";
import store from "@/store/Store";
//import Swal from "sweetalert2";

axios.interceptors.request.use((config) => {
  const indexInterrogacao = config.url.indexOf("?");
  const indexUltimaBarra = config.url.lastIndexOf("/");
  if (indexInterrogacao < indexUltimaBarra && indexInterrogacao >= 0) {
    config.url = config.url.substring(0, config.url.length - 1);
  }
  return config;
});

axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});


/*axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if(error.request){
    Swal.fire({
      title: "Erro",
      text: "Ocorreu um erro ao conectar com o servidor. Tente novamente mais tarde.",
      icon: "error",
      confirmButtonText: "Ok"
    });
  }
  return Promise.reject(error);
});*/
/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    this.setbaseURL(API_URL);
  },
  setbaseURL(url) {
    Vue.axios.defaults.baseURL = url;
  },
  getbaseURL() {
    this.init();
    return Vue.axios.defaults.baseURL;
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    this.init();
    Vue.axios.defaults.headers.common["Authorization"] = `Bearer ${Jwt.buscarToken()}`;
    Vue.axios.defaults.headers.common["SelectedCompany"] = store.state.app.selectedCompany;
    this.setbaseURL(API_URL);
    Vue.axios.defaults.headers.common["Content-Language"] = "pt-br";
  },

  query(resource, params) {
    return Vue.axios.get(resource, params);
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  get(resource, slug = "") {
    this.setHeader();
    return Vue.axios.get(`${resource}/${slug}`);
  },
  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params, file, campoFile) {
    this.setHeader();

    if (file) {
      let formData = new FormData();

      formData.append(campoFile, file);

      for (const key in params) {
        if (Object.hasOwnProperty.call(params, key)) {
          if (key != campoFile) {
            formData.append(key, params[key]);
          }
        }
      }

      return Vue.axios.post(`${resource}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    } else {
      return Vue.axios.post(`${resource}`, params);
    }
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    this.setHeader();
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params, file, campoFile) {
    this.setHeader();

    if (file) {
      let formData = new FormData();

      formData.append(campoFile, file);

      for (const key in params) {
        if (Object.hasOwnProperty.call(params, key)) {
          if (key != campoFile) {
            formData.append(key, params[key]);
          }
        }
      }

      return Vue.axios.put(`${resource}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    } else {
      return Vue.axios.put(`${resource}`, params);
    }
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource, params) {
    this.setHeader();
    return Vue.axios.delete(`${resource}`, { data: params });
  },
  uploadFile(resource, file) {
    let data = new FormData();
    data.append("fileName", file.name);
    data.append("file", file);
    let config = {
      header: {
        "Content-Type": "multipart/form-data",
      },
    };

    return this.post(resource, data, config);
  },
  /**
   * Download file with the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
   downloadFile(resource, slug = "") {
    this.setHeader();
    return Vue.axios.get(`${resource}/${slug}`,{ responseType: 'blob' });
  },
};

export default ApiService;
